import React from 'react';
import PropTypes from 'prop-types';
import closedIcon from '../../../images/Autocode/arrow_closed.svg';
import openedIcon from '../../../images/Autocode/arrow_opened.svg';
import {
  ACClosedIcon,
  ACNode,
  ACNodeLabel,
  ACOpenedIcon,
} from '../styledComponents';
import ACTreeAnswerNode from './ACTreeAnswerNode';
import {
  AC_RECTYPE_Q,
  AC_RECTYPE_S,
  AC_RECTYPE_T,
  TEMPLATE_TYPE_1,
  TEMPLATE_TYPE_2,
  TEMPLATE_TYPE_7,
  TEMPLATE_TYPE_8,
} from '../AutocodeConstants';

const ACTreeNode = ({ node, clickHandler, level }) => {
  const nodeClickHandler = e => {
    e.preventDefault();
    clickHandler(node);
  };

  const renderNode = () => {
    if (
      node.templateType &&
      node.templateType === TEMPLATE_TYPE_1 &&
      node.rectype === AC_RECTYPE_T
    ) {
      return (
        <ACTreeAnswerNode
          node={node}
          nodeClickHandler={nodeClickHandler}
          level={level}
        />
      );
    }
    if (
      node.templateType &&
      node.templateType !== TEMPLATE_TYPE_1 &&
      node.rectype === AC_RECTYPE_T
    ) {
      return (
        <ACTreeAnswerNode
          node={node}
          nodeClickHandler={nodeClickHandler}
          level={level}
        />
      );
    }
    if (
      node.templateType &&
      node.templateType === TEMPLATE_TYPE_2 &&
      node.rectype === AC_RECTYPE_S
    ) {
      return (
        <ACTreeAnswerNode
          node={node}
          nodeClickHandler={nodeClickHandler}
          level={level}
        />
      );
    }
    if (
      node.templateType &&
      (node.templateType === TEMPLATE_TYPE_7 ||
        node.templateType === TEMPLATE_TYPE_8) &&
      node.rectype === AC_RECTYPE_S
    ) {
      return (
        <ACTreeAnswerNode
          node={node}
          nodeClickHandler={nodeClickHandler}
          level={level}
        />
      );
    }
    if (node.rectype === AC_RECTYPE_Q) {
      return (
        <ACTreeAnswerNode
          node={node}
          nodeClickHandler={nodeClickHandler}
          level={level}
        />
      );
    }
    return (
      <ACNode onClick={nodeClickHandler} level={level}>
        {!node.isOpened && <ACClosedIcon src={closedIcon} alt="Closed Icon" />}
        {node.isOpened && <ACOpenedIcon src={openedIcon} alt="Opened Icon" />}
        <ACNodeLabel font={node.isOpened}>{node.shortText}</ACNodeLabel>
      </ACNode>
    );
  };

  return (
    <React.Fragment>
      {renderNode()}
      {node.isOpened &&
        node.children &&
        node.children.map(child => (
          <ACTreeNode
            node={child}
            // textPath isn't always unique, append node or recno to make it so
            key={`${child.textPath}-${child.node || child.recno}`}
            clickHandler={clickHandler}
            level={level + 1}
          />
        ))}
    </React.Fragment>
  );
};

ACTreeNode.propTypes = {
  node: PropTypes.shape({
    shortText: PropTypes.string,
    isOpened: PropTypes.bool,
    children: PropTypes.instanceOf(Array),
    rectype: PropTypes.string,
    isSelected: PropTypes.bool,
    templateType: PropTypes.string,
  }),
  clickHandler: PropTypes.func.isRequired,
  level: PropTypes.number.isRequired,
};

ACTreeNode.defaultProps = {
  node: {
    isOpened: false,
    isSelected: false,
  },
};

export default ACTreeNode;
